var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.fileMissing)?_c('img',{staticClass:"img-thumbnail",attrs:{"src":_vm.link,"alt":"..."},on:{"error":_vm.onImageError}}):_c('div',{staticClass:"file-missing"},[_c('span',{staticClass:"error-text"},[_vm._v(_vm._s(_vm.$t("error-messages.load-image")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }